import OTPVerification from "./OTPVerification";

const SignupOTP = () => {
  return (
    <OTPVerification
      title="Create Account"
      buttonText="Sign Up"
      redirectPath="/"
    />
  );
};

export default SignupOTP;